import { Header, type SharedHeaderProps } from '@lmn/contenthub-shared/components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { Brand } from '@/domainLogic/index.ts';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';
import StaticHeader from '@/app/common/headerFooter/StaticHeader.tsx';

const staticHeaderFallback = () => <StaticHeader />;

const ContentHubHeader = (props: SharedHeaderProps) => {
  const { localization } = usePageWrapperData();
  const { brand } = localization;
  const isLM = brand === Brand.LASTMINUTE;

  return (
    <ErrorBoundary id="ContentHubHeader" fallback={staticHeaderFallback}>
      <Header {...props} {...(!isLM && { isSmallLogoOnMobileEnabled: false })} />
    </ErrorBoundary>
  );
};

export default ContentHubHeader;
